import styles from "./pet-list.module.css";
import PetFilter from "../Filter";
import { TableLoader } from "../../../../components/LoaderC";
import List from "./component/List";
import Graph from "./component/Graph";
import { useState } from "react";

const PetListView = ({
  contentLoading,
  allData,
  isGridView,
  handleView,
  filterData,
  setFilterData,
  setAddModalOpen,
  setEditModalOpen,
  setEditData,
  isListChange,
}) => {
  const [page, setPage] = useState(0);
  return (
    <div className={`${styles.BodyCon}`}>
      <div className={`${styles.mainCardDiv}`}>
        <div className={`${styles.mainCard}`}>
          <div className="control-pane">
            {contentLoading && (
              <div className="Loader TableLoader">
                <TableLoader />
              </div>
            )}
            {/* <div className={`${styles.Row}`}>
              <PetFilter
                isGridView={isGridView}
                handleView={handleView.bind(this)}
                filterData={filterData}
                setFilterData={setFilterData.bind(this)}
                setAddModalOpen={setAddModalOpen.bind(this)}
              />
              List
            </div> */}

            {!contentLoading && (
              <>
                <PetFilter
                  isGridView={isGridView}
                  handleView={handleView.bind(this)}
                  filterData={filterData}
                  setFilterData={setFilterData.bind(this)}
                  setAddModalOpen={setAddModalOpen.bind(this)}
                  setPage={setPage.bind(0)}
                />

                <div className={`${styles.IncomeListingBody}`}>
                  <div className={`${styles.IncomeListSec}`}>
                    <List
                      allData={allData}
                      filterData={filterData}
                      setEditData={setEditData.bind(this)}
                      setEditModalOpen={setEditModalOpen.bind(this)}
                    />
                  </div>
                  <div className={`${styles.IncomeGraphSec}`}>
                    <Graph
                      filterData={filterData}
                      isListChange={isListChange}
                    />
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PetListView;
